module.exports = __webpack_public_path__ + "static/img/map_off.d6a111dd.svg";